import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  requestPaymentMethodInfo,
  requestPaymentMethodUpdate,
  requestPaymentMethodDestroy,
} from 'requests/payment-methods'
import useInfo from 'hooks/useInfo'
import { InfoPage } from 'templates/InfoPage'
import { ProgressBar } from 'ui-components/ProgressBar'
import { SlideDialog } from 'ui-components/SlideDialog'
import { SideMenu } from 'components/SideMenu'
import { Form } from 'components/PaymentMethod/Form'
import { SETTINGS_SUBMENU } from 'constants/menu/submenus'
import { BasicInfo } from './components/BasicInfo'
import { PaymentPlansList } from './components/PaymentPlansList'

export default function PaymentMethodInfo() {
  const [toEdit, setToEdit] = useState(false)
  const { id } = useParams()

  const [paymentMethod, infoState, infoActions] = useInfo({
    id,
    requestInfo: requestPaymentMethodInfo,
    requestUpdate: requestPaymentMethodUpdate,
    requestDestroy: requestPaymentMethodDestroy,
  })

  const onCancelEdit = () => {
    setToEdit(false)
  }

  const onUpdate = () => {
    infoActions.update()
  }

  const renderErrorMessage = () => {

  }

  const renderMenu = () => (
    <SideMenu submenu={SETTINGS_SUBMENU} />
  )

  const renderPaymentMethod = () => (
    <div>
      <BasicInfo paymentMethod={paymentMethod} />
      <PaymentPlansList
        paymentMethod={paymentMethod}
        onSavePlan={infoActions.getInfo}
      />
    </div>
  )

  return (
    <InfoPage
      renderMenu={renderMenu}
      title={paymentMethod?.attributes?.name}
      subtitle="Forma de pagamento"
      onEdit={() => setToEdit(true)}
    >
      <ProgressBar start={infoState.processing} />

      <SlideDialog open={toEdit} onClose={onCancelEdit}>
        <Form
          paymentMethod={paymentMethod}
          onCancel={onCancelEdit}
          onSave={onUpdate}
          saving={infoState.saving}
          responseError={infoState.responseError}
        />
      </SlideDialog>
      { infoState.loading ? null : renderPaymentMethod() }
      { infoState.responseError ? renderErrorMessage() : null }
    </InfoPage>
  )
}
